import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import { Container,Row, Col } from 'react-bootstrap';

function Main() {
    return(
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Research"/>
            <section className="project-detail">
                <div className='container'>
                    <Row>
                        <Col md={6} className='c-left mb-3'>
                            <div className="border">
                                <div className='mt-3'>
                                    <div className='ms-3'>
                                        <h4 className='mb-3'>Patents</h4>
                        
                                <ul className='myulcustarrow'>
                                    <li> <a href = "https://files.iittp.ac.in/pdfs/csrc/TECHNOLOGY_AVAILABLE_FOR_TRANSFER.pdf" target="_blank"> Technology Available for Transfer</a> </li>
                                    <li> <a href = "https://files.iittp.ac.in/pdfs/csrc/PATENT PROCESS IIT Tirupati.pdf" target="_blank"> Patent Process </a> </li>
                                    <li> <Link to ={"https://files.iittp.ac.in/pdfs/csrc/IDF template.docx"}> Invention Disclousure Format - Template </Link> </li>
                                
                            
                                 </ul> 
                                    </div>
                                </div>
                            </div> 
                        </Col>
                         <Col md={6} className='c-left'>
                            <div className="border">
                                <div className='mt-3'>
                                    <div className='ms-3'>
                                        <h4 className='mb-3'> Technology Transfer </h4>
                                    
                            
                                    <ul className='myulcustarrow'>
                                        <li> <Link to ={"https://files.iittp.ac.in/pdfs/csrc/Letter of Intent.docx" }> Letter of Intent </Link> </li>
                                        <li> <Link to ="https://files.iittp.ac.in/pdfs/csrc/Process Guide - Funded Research.docx.pdf" target="_blank"> Process Guide - Funded Research </Link> </li>
                                        <li> <Link to = "https://files.iittp.ac.in/pdfs/csrc/Process Guide -Licensing of listed IP.pdf" target="_blank"> Process Guide (Licensing of listed IP)</Link> </li>
                                        <li> <Link to ={"https://files.iittp.ac.in/pdfs/csrc/AGREEMENT TECHTRANSFER TEMPLATE.docx"}> Agreement for Technology Transfer - Template </Link> </li>
                                        <li> <Link to ={"https://files.iittp.ac.in/pdfs/csrc/Licensing_Agreement_Template.doc"}> Technology Licensing Agreement - Template </Link> </li>
                                        <li> <Link to ={"https://files.iittp.ac.in/pdfs/csrc/NDA.rtf"}> Non Disclosure Agreement </Link> </li>
                                        <li> <Link to ={"https://files.iittp.ac.in/pdfs/csrc/Standard%20IIA%20Template.doc"}> Inter Institutional Agreement - Template </Link></li>
                                        
                                    </ul>  
                                    </div>
                                </div>
                            </div>
                        </Col>



                    </Row>
                </div>
            </section>
        </>
    );
}

export default Main;